import { Component, OnInit } from '@angular/core';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { HeaderService } from '@headerservice/header.service';


@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.css'],
    standalone: false
})
export class AnnouncementComponent implements OnInit {

  public createdDate: any;
  public Desc: string;
  AnnouncementID: number;
  AnnouncementDetails: any = [];

  // constructor(private headerService: HeaderService) {
  //   this.getAnnouncement();
  // }

  ngOnInit() { }
  // getAnnouncement() {
  //   this.headerService.getAnnouncement().subscribe(
  //     p => {
  //       this.AnnouncementDetails = p;
  //       for (let data in this.AnnouncementDetails) {
  //         if (this.AnnouncementDetails.hasOwnProperty(data)) {
  //         this.createdDate = this.AnnouncementDetails[data].createdDate;
  //         this.Desc = this.AnnouncementDetails[data].description;
  //         }
  //       }
  //     });
  // }

}
